<!-- <div class="text-center mb-4">
  <div class="card ">
    <img [src]="blog.url_imagen" class="card-img-top" alt="...">
    <div class="card-body">
      <p class="card-title font-weight-bolder"><b>
          “{{blog.title}}”
        </b></p>
      <p class="card-text text-sm">
        {{blog.resumen}}
      </p>
    </div>
  </div>
  <input *ngIf="viewBtn" (click)="goTo(blog.link)" class="btn custom-cta border-btn mt-5" type="button"
    value="Leer más">
</div> -->
<div class="q-card__news">
  <div class="q-card__news__image">
    <img decoding="async" width="938" height="549" [src]="blog.url_imagen" alt="Noticias" srcset="">
  </div>
  <div class="q-card__news__title">{{blog.title}}</div>
  <div class="q-card__news__resumen">{{blog.resumen}}</div>
  <div class="q-card__news__link" *ngIf="blog.link_detalle">
    <a class="btn custom-cta border-btn" target="_blank" [href]="blog.link_detalle">{{ 'app.see_more' | translate }}</a>
  </div>
</div>